import { useCallback, useState } from 'react';

import { trackEvent } from '@/utils/fullstory';

import styles from './landingPage.module.css';
import { AgentRepliesSection } from './sections/AgentRepliesSection';
import { Footer } from './sections/Footer';
import { FromBriefSection } from './sections/FromBriefSection';
import { HeroSection } from './sections/HeroSection';
import { Nav } from './sections/Nav';
import { OneAgentSection } from './sections/OneAgentSection';
import { OnePlatformSection } from './sections/OnePlatformSection';
import { WaitlistModal } from './WaitlistModal.tsx';

type LandingPageProps = {
	onAuth: () => void;
	showLogout?: boolean;
	onLogout?: () => void;
	isInvited?: boolean;
};

export const LandingPage = ({
	onAuth,
	showLogout,
	onLogout,
	isInvited = false,
}: LandingPageProps) => {
	const [waitlistOpen, setWaitlistOpen] = useState(false);

	const handleCta = useCallback(() => {
		trackEvent('Clicked Get Started on landing page');
		if (isInvited) onAuth();
		else setWaitlistOpen(true);
	}, [isInvited, onAuth]);

	const handleWaitlist = useCallback(() => {
		trackEvent('Clicked Join Waitlist on landing page');
		setWaitlistOpen(true);
	}, []);

	return (
		<div className={styles.landing}>
			<Nav
				isInvited={isInvited}
				showLogout={showLogout}
				onAuth={onAuth}
				onLogout={onLogout}
				onWaitlist={handleWaitlist}
			/>
			<main>
				<HeroSection onCta={handleCta} isInvited={isInvited} />
				<FromBriefSection onCta={handleCta} />
				<OneAgentSection onCta={handleCta} />
				<OnePlatformSection onCta={handleCta} />
				<AgentRepliesSection onCta={handleCta} />
			</main>
			<Footer onCta={handleCta} />
			{waitlistOpen && <WaitlistModal onClose={() => setWaitlistOpen(false)} />}
		</div>
	);
};
